import { convertFromRaw, EditorState } from 'draft-js';
import { useEffect, useRef, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

// Helper function to validate RawDraftContentState
function isValidRawDraftContentState(raw) {
    return (
        raw &&
        typeof raw === 'object' &&
        Array.isArray(raw.blocks) &&
        typeof raw.entityMap === 'object'
    );
}

export default function DisplayTextComponent({
    component,
    onUserInput,
    onUserInputComplete,
    defaultValues,
}) {
    const [editorState, setEditorState] = useState(() => {
        console.log("defaultValues", defaultValues, component);

        if (typeof defaultValues === 'string' && defaultValues.startsWith('{')) {
            try {
                defaultValues = JSON.parse(defaultValues);
            } catch (e) {
                console.warn("Failed to parse defaultValues as JSON", e);
            }
        }

        if (isValidRawDraftContentState(defaultValues)) {
            return EditorState.createWithContent(convertFromRaw(defaultValues));
        }

        if (!component) return EditorState.createEmpty();

        if (typeof component.question === 'string' && component.question.startsWith('{')) {
            try {
                const parsedQuestion = JSON.parse(component.question);
                if (isValidRawDraftContentState(parsedQuestion)) {
                    return EditorState.createWithContent(convertFromRaw(parsedQuestion));
                }
            } catch (e) {
                console.warn("Failed to parse component.question as JSON", e);
            }
        }

        if (isValidRawDraftContentState(component.question)) {
            return EditorState.createWithContent(convertFromRaw(component.question));
        }

        return EditorState.createEmpty();
    });

    const debounceTimeout = useRef();

    useEffect(() => {
        return () => {
            if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        };
    }, [debounceTimeout]);

    const handleEditorChange = (state) => {
        setEditorState(state);
        const value = JSON.stringify(editorState.getCurrentContent());
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
            onUserInput(value);
        }, 1000);
    };

    const handleBlur = () => {
        const value = JSON.stringify(editorState.getCurrentContent());
        onUserInputComplete && onUserInput(value);
    };

    return (
        <div onMouseDown={(e) => e.stopPropagation()}>
            <Editor
                editorState={editorState}
                onEditorStateChange={handleEditorChange}
                onBlur={handleBlur}
                toolbarHidden={true}
                readOnly={true}
                wrapperClassName="wysiwyg-wrapper"
                editorClassName="wysiwyg-editor"
            />
        </div>
    );
}
